import React, { useRef, useMemo, useState } from "react";
import styled from "styled-components";

import { CustomTextarea } from "components/Form/CustomTextarea";
import { CustomModal } from "components/base";
import { Alert } from "services/Alert";
import {
    PROTECTED_RANGES_CREATE_TEXT_API,
    SMS_PROTECTED_RANGES_CREATE_TEXT_API
} from "const/apiMethods";
import { servicePick } from "utils";


import { api } from "api/loginRoutes";
import { Form, Schema } from "rsuite";

const { StringType } = Schema.Types;

const MIN_CHARACTERS = 3;
const MAX_CHARACTERS = 15;
const MAX_ROWS = 10000;

const DEFAULT_FORM_VALUE = {};

export default ({
    show = false,
    loading = false,
    maxWidth = 600,
    resizedWidth,

    service,
    onClose,
    onSuccess,

    setLoading,
    ...props
}) => {
    const formRef = useRef(null);
    const [formValue, setFormValue] = useState(DEFAULT_FORM_VALUE);

    const formModel = useMemo(() => {
        return Schema.Model({
            prefix_text: StringType()
                .isRequired("This field is required")
                .addRule((value) => {
                    const rows = value.trim().split("\n");
                    for (const row of rows) {
                        if (row.length < MIN_CHARACTERS) {
                            return false;
                        } else if (row.length > MAX_CHARACTERS) {
                            return false;
                        }
                    }

                    return true;
                }, `Each row should be greater than ${MIN_CHARACTERS} and less than ${MAX_CHARACTERS}`)
                .addRule((value) => {
                    const rows = value.trim().split("\n");
                    return !(rows.length > MAX_ROWS);
                }, `The number of entered prefixes exceeds ${MAX_ROWS} rows`),
            comment: StringType()
                .maxLength(255, "The maximum is 255 characters")
        });
    }, []);


    const handleSubmit = () => {
        if (!formRef.current.check()) {
            return;
        }

        const params = { ...formValue };

        const rows = params.prefix_text.trim().split("\n");
        const prefixCount = rows.length;

        const method = servicePick(service, PROTECTED_RANGES_CREATE_TEXT_API, SMS_PROTECTED_RANGES_CREATE_TEXT_API);

        setLoading(true);

        api(method, params)
            .then(response => {
                if (!response) {
                    return;
                }

                if (response.error) {
                    return;
                }

                let createdCount = 0;

                if (response && response["created/updated"]) {
                    createdCount = response["created/updated"];
                }

                if (createdCount) {
                    Alert.success(`Successfully added ${createdCount} ranges`);
                } else {
                    Alert.info("No new ranges were added");
                }

                onSuccess();
                onClose();

                setFormValue(DEFAULT_FORM_VALUE);
            })
    };

    return (<StyledModal
        show={show}
        showFooter={true}
        title="Add new ranges"
        width={resizedWidth > maxWidth ? maxWidth : resizedWidth}
        onConfirm={handleSubmit}
        loading={loading}
        onClose={() => {
            onClose();
            setFormValue(DEFAULT_FORM_VALUE);
        }}
        onExited={() => {
            onClose();
            setFormValue(DEFAULT_FORM_VALUE);
        }}
    // {...props}
    >
        <Form
            ref={formRef}
            model={formModel}
            formValue={formValue}
            onChange={setFormValue}
        >
            <Form.Group>
                <Form.ControlLabel>Prefix list</Form.ControlLabel>
                <Form.Control
                    name="prefix_text"
                    accepter={StyledTextarea}
                    placeholder="Prefix list"
                    componentClass="textarea"
                    style={{ height: 120 }}
                />
            </Form.Group>
            <Form.Group>
                <Form.ControlLabel>Comment</Form.ControlLabel>
                <Form.Control
                    name="comment"
                    accepter={StyledTextarea}
                    placeholder="Comment"
                    componentClass="textarea"
                    style={{ height: 140 }}
                />
            </Form.Group>
        </Form>
    </StyledModal>)
};

const StyledModal = styled(CustomModal)`
`;

export const StyledTextarea = styled(CustomTextarea)`
    &&& {
    }
`;
